module.exports = __webpack_public_path__ + "img/9_fineStaff_ghy.2c7cafa3.png";